<template>
  <BittsEmptyState
    title="The Salesforce App isn't installed"
    svg-name="emptyStateFreeAccount"
  >
    <template #subtitle>
      <div class="sf-overlap-settings-drawer__empty-state--description">
        To use this integration, follow these steps below:
      </div>
      <ol class="list-decimal list-inside">
        <li>
          <BittsLink
            url="https://appexchange.salesforce.com/appxListingDetail?listingId=a0N3A00000FvKuqUAF"
            text="Install Package"
          />
        </li>
        <li>
          <BittsLink
            :url="sfCrossbeamAppLink"
            text="Setup Salesforce Crossbeam App"
            :open-in-new-tab="true"
          />
        </li>
      </ol>
    </template>
  </BittsEmptyState>
</template>

<script setup lang="ts">
import { BittsEmptyState, BittsLink } from '@crossbeam/bitts';

import { computed } from 'vue';

import appConfig from '@/config';

const sfCrossbeamAppLink = computed(() => {
  return `https://login.salesforce.com/${appConfig.salesforceReauthUrl}`;
});
</script>
